import { StaticImage } from 'gatsby-plugin-image';
import { Box } from '@hover/blueprint';
import React from 'react';

const SlideMobile: React.FC = () => (
  <Box mt={800} d={{ base: 'flex', tablet: 'none' }}>
    <StaticImage
      quality={100}
      placeholder="blurred"
      alt="trusted by names"
      src="../../../assets/images/trusted_by_Names.png"
    />
  </Box>
);

export default SlideMobile;
